import { pseudoTagStringFromGQL, pseudoTagStringToGQL } from 'utils/coercionUtils';
import { CONSENT_CHANNELS, FIELD_NAMES } from 'utils/constants';

function fromGQL(obj) {
  const { value, ...returnableField } = obj;

  const gqlGDPRConsentData = { ...value };
  const gdprConsentData = {};
  gdprConsentData.retailOptIn = {
    text: pseudoTagStringFromGQL(gqlGDPRConsentData.retailOptIn.text),
    channelData: channelDataFromGQL(gqlGDPRConsentData.retailOptIn),
  };
  gdprConsentData.leadShareOptIn = {
    include: gqlGDPRConsentData.leadShareOptIn.text.length > 0,
    text: pseudoTagStringFromGQL(gqlGDPRConsentData.leadShareOptIn.text),
    leadShareValue: gqlGDPRConsentData.leadShareOptIn.leadShareValue,
    channelData: channelDataFromGQL(gqlGDPRConsentData.leadShareOptIn),
  };
  gdprConsentData.disclaimer = {
    include: gqlGDPRConsentData.disclaimer.length > 0,
    text: pseudoTagStringFromGQL(gqlGDPRConsentData.disclaimer),
  };
  return {
    ...returnableField,
    name: FIELD_NAMES.CONSENT_GDPR,
    editors: {
      gdprConsentData,
    },
  };
}

function channelDataFromGQL(gqlData) {
  return {
    email: {
      include: gqlData.email.length > 0,
      text: gqlData.email,
    },
    phone: {
      include: gqlData.phone.length > 0,
      text: gqlData.phone,
    },
    sms: {
      include: gqlData.sms.length > 0,
      text: gqlData.sms,
    },
  };
}

function toGQL({ editors }) {
  const { retailOptIn, leadShareOptIn, disclaimer } = editors.gdprConsentData;
  const valueObj = {};
  valueObj.retailOptIn = { text: pseudoTagStringToGQL(retailOptIn.text) };
  CONSENT_CHANNELS.forEach((channel) => {
    valueObj.retailOptIn[channel] = retailOptIn.channelData[channel].include ? retailOptIn.channelData[channel].text : '';
  });
  valueObj.leadShareOptIn = {
    text: '',
    leadShareValue: '',
    email: '',
    phone: '',
    sms: '',
  };
  if (leadShareOptIn.include) {
    valueObj.leadShareOptIn.text = pseudoTagStringToGQL(leadShareOptIn.text);
    valueObj.leadShareOptIn.leadShareValue = leadShareOptIn.leadShareValue;
    CONSENT_CHANNELS.forEach((channel) => {
      valueObj.leadShareOptIn[channel] = leadShareOptIn.channelData[channel].include ? leadShareOptIn.channelData[channel].text : '';
    });
  }
  valueObj.disclaimer = disclaimer.include ? pseudoTagStringToGQL(disclaimer.text) : '';
  return { value: valueObj, name: FIELD_NAMES.LEAD_SHARE_OPT_IN };
}

export default {
  fromGQL,
  toGQL,
};
